import { useState, useEffect } from "react";

export function useScreenHorizontal(breakpoint = 1430) {
    const [isMobile, setIsMobile] = useState(
        window.innerWidth < breakpoint
    );

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth < breakpoint);
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
}

export function useScreenVertical(breakpoint = 800) {
    const [isMobile, setIsMobile] = useState(
        window.innerHeight < breakpoint
    );

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerHeight < breakpoint);
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);

    return isMobile;
}